export const GET_ORDERBLOCK_BY_ID_M = (id, preview: boolean) => `
  query {
    orderBlock(id: "${id}", preview: ${preview}) {
      thumbnailFormat
      hideDownloadLinks
      sys{
        id
      }
        mainAreaOrderCollection {
          items {
            ... on FileBlock{
              name
              imageVaultFile
              metaData
              ivThumbnail
              __typename
              sys{
                publishedAt
                firstPublishedAt
                id
                __typename
              }
            }
          }
        }
      }
  }
`;
export const GET_ORDERBLOCK_EMAIL_RECIEVER_M = (id: string, preview: boolean) => `
  query {
    orderBlock(id: "${id}", preview: ${preview}) {
      emailAddress
    }
  }
`;
